import { ComponentsModule } from './../../components/components.module';
import { NgModule } from '@angular/core';
import { IonicPageModule } from 'ionic-angular';
import { CronosListsPage } from './cronos-lists';

@NgModule({
  declarations: [
    CronosListsPage,
  ],
  imports: [
    ComponentsModule,
    IonicPageModule.forChild(CronosListsPage)
  ],
})
export class CronosListsPageModule {}



// WEBPACK FOOTER //
// ./src/pages/cronos-lists/cronos-lists.module.ts